import APIGroupDetailLayout from './APIGroupDetailLayout';

export default APIGroupDetailLayout;
